import { ShipmentQuickFilters } from '../../../../models';

export const CONTAINER_CHARGES = [
  {
    active: false,
    name: ShipmentQuickFilters.Ok,
    count: 0,
  },
  {
    active: false,
    name: ShipmentQuickFilters.AtRisk,
    count: 0,
  },
  {
    active: false,
    name: ShipmentQuickFilters.Breached,
    count: 0,
  },
];
